<template>
  <div class="sections">
    <div class="container">
      <div class="row sections__items-row">

        <div
          v-for="subject in subjectsList"
          :key="subject.id"
          class="col-12 col-xl-1-5 sections__item text-center"
          :class="{'sections__item--disabled': subject.complete}">
          <div @click="goToSubject(subject)" class="sections__img-container">
            <img class="sections__img" :src="'/static/img/'+subject.name+'.svg'" alt="">
          </div>
          <span @click="goToSubject(subject)" class="sections__btn">
            {{ subject.name }}
          </span>
        </div>
      </div>
    </div>

    <div v-if="$current_user.completed_sections < 5" class="sections__dialog">
      <div class="container">
        <div class="row">

          <div v-if="!finishedSection && $current_user.completed_sections === '0'" class="col-12">
            <h1 class="sections__dialog-title">Pick where to start</h1>
            <p class="sections__dialog-text">
              Pick where you’d like to begin. You will be assessing your organisation in five areas:
              Purpose, Ecosystems, Adaptability, Real Empowerment and Leadership.
            </p>
            <img class="sections__dialog-img" src="~assets/img/evaluation-rocket.svg" alt="">
          </div>

          <div v-else-if="!finishedSection" class="col-12">
            <h1 class="sections__dialog-title">Select next section</h1>
            <p class="sections__dialog-text">
              You will be assessing your organisation in five areas:
              Purpose, Ecosystems, Adaptability, Real Empowerment and Leadership.
            </p>
            <img class="sections__dialog-img" src="~assets/img/evaluation-rocket.svg" alt="">
          </div>

          <div v-else class="col-12">
            <h1 class="sections__dialog-title">{{ finishedSection }} Complete!</h1>
            <p class="sections__dialog-text">
              Please select next section.
            </p>
            <img class="sections__dialog-img" src="~assets/img/icon-done.svg" alt="">
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
// API
import subjectsApi from '@/api/subjects';

export default {
  props: ['finishedSection'],
  data() {
    return {
      subjectsList: [],
      completedSubject: '',
    };
  },
  computed: {
  },
  methods: {
    goToSubject(subject) {
      if (!subject.complete) {
        this.$router.push({ name: subject.name, params: { sectionId: subject.id } });
      }
    },
  },
  beforeCreate() {
    if (this.$current_user.current_evaluation !== this.$route.params.id) {
      this.$router.push({ name: 'start' });
    } else if (this.$current_user.completed_sections === '5') {
      this.$router.push({ name: 'finish' });
    }
  },
  created() {
    subjectsApi.index().then((response) => {
      this.subjectsList = response.data.subjects;
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Evaluation/Sections.vue